import { ROUTES } from "@/constants/routes";
import { route } from "@/utils/route";

/**
 * Absolute deep link to a file record's detail view. This is the internal
 * share link surfaced inside the Share dialog — it only resolves for users the
 * file has been shared with (or who can already reach its parent scope), so we
 * keep it tucked behind sharing rather than offering it as a standalone action.
 */
export function buildFileRecordDetailUrl(fileRecordId: string): string {
  return `${window.location.origin}${route(ROUTES.FILE_RECORDS.DETAIL, {
    fileRecordId,
  })}`;
}
